export enum RelativePositionAlignmentEnums {
  topStart = 'topStart',
  topCenter = 'topCenter',
  topEnd = 'topEnd',
  middleStart = 'middleStart',
  middleCenter = 'middleCenter',
  middleEnd = 'middleEnd',
  bottomStart = 'bottomStart',
  bottomCenter = 'bottomCenter',
  bottomEnd = 'bottomEnd',
}

export type RelativePositionAlignment =
  | 'topStart'
  | 'topCenter'
  | 'topEnd'
  | 'middleStart'
  | 'middleCenter'
  | 'middleEnd'
  | 'bottomStart'
  | 'bottomCenter'
  | 'bottomEnd';

export type FixedPositionProperty =
  | 'top'
  | 'left'
  | 'bottom'
  | 'right'
  | 'transform';

export type FixedPositionProperties = {
  [position in FixedPositionProperty]?: string;
};

export enum EngineIncomingNotificationMessage {
  showSnackbar = 'showSnackbar',
  dismissSnackbar = 'dismissSnackbar',
}
export enum EngineOutgoingNotificationMessage {
  snackbarActionClick = 'snackbarActionClick',
}

export * from './overflowCalculations';
